import { Size } from '@lessonup/pins-shared';
import React from 'react';

export interface EllipseShapeProps {
  size: Size;
  strokeWidth: number;
}

export const EllipseShape: React.FC<EllipseShapeProps> = ({ size, strokeWidth }) => {
  const cx = size.width / 2;
  const cy = size.height / 2;
  const rx = (size.width - strokeWidth) / 2;
  const ry = (size.height - strokeWidth) / 2;

  return <ellipse cx={cx} cy={cy} rx={rx} ry={ry} />;
};
